import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { translate, DashboardMenuItem, MenuItemLink } from 'admin-on-rest';

//import CustomerIcon from 'material-ui/svg-icons/social/person-add';
//import MoneyIcon from 'material-ui/svg-icons/editor/attach-money';
import CogIcon from 'material-ui/svg-icons/content/create';

const items = [
    { name: 'member/ads', label: 'Mijn advertenties', icon: <CogIcon /> },
];

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: '100%',
    },
};

const Menu = ({ onMenuTap, translate, logout }) => (
    <div style={styles.main}>
        <DashboardMenuItem onClick={onMenuTap} />
        {items.map(item => (
            <MenuItemLink
                key={item.name}
                to={`/${item.name}`}
                primaryText={item.label}
                leftIcon={item.icon}
                onClick={onMenuTap}
            />
        ))}
        {logout}
    </div>
);

const enhance = compose(
    connect(state => ({
        theme: state.theme,
        locale: state.locale,
    })),
    translate,
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/Menu.js